const FloatingEphemera = () => {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden opacity-30 md:opacity-40">
      {/* Postage stamp 1 - Portugal */}
      <div className="absolute top-20 left-[5%] md:left-[10%] animate-float">
        <div className="h-10 w-8 md:h-16 md:w-12 rounded border-2 border-dashed border-tan bg-cream-dark/50 flex items-center justify-center">
          <span className="font-serif text-[6px] md:text-[8px] text-charcoal-light uppercase">Portugal</span>
        </div>
      </div>

      {/* Postage stamp 2 - Japan */}
      <div className="absolute top-40 right-[5%] md:right-[15%] animate-float-delayed">
        <div className="h-10 w-7 md:h-14 md:w-10 rounded border-2 border-dashed border-secondary bg-cream-dark/50 flex items-center justify-center rotate-12">
          <span className="font-serif text-[5px] md:text-[7px] text-charcoal-light uppercase">日本</span>
        </div>
      </div>

      {/* Postage stamp 3 - Italy */}
      <div className="absolute top-[15%] right-[25%] md:right-[35%] animate-float-slow">
        <div className="h-9 w-7 md:h-12 md:w-9 rounded border-2 border-dashed border-burgundy/40 bg-cream-dark/50 flex items-center justify-center rotate-[-8deg]">
          <span className="font-serif text-[5px] md:text-[7px] text-charcoal-light uppercase">Italia</span>
        </div>
      </div>

      {/* Postage stamp 4 - France */}
      <div className="absolute top-[55%] left-[8%] md:left-[3%] animate-float">
        <div className="h-8 w-10 md:h-11 md:w-14 rounded border-2 border-dashed border-primary/30 bg-cream-dark/50 flex items-center justify-center rotate-[5deg]">
          <span className="font-serif text-[5px] md:text-[7px] text-charcoal-light uppercase">France</span>
        </div>
      </div>

      {/* Postage stamp 5 - Greece */}
      <div className="absolute top-[70%] right-[8%] md:right-[5%] animate-float-delayed">
        <div className="h-10 w-8 md:h-14 md:w-11 rounded border-2 border-dashed border-tan bg-cream-dark/50 flex items-center justify-center rotate-[-12deg]">
          <span className="font-serif text-[5px] md:text-[7px] text-charcoal-light uppercase">Ελλάδα</span>
        </div>
      </div>

      {/* Postage stamp 6 - Spain */}
      <div className="absolute top-[8%] left-[40%] md:left-[45%] animate-float">
        <div className="h-8 w-6 md:h-12 md:w-9 rounded border-2 border-dashed border-secondary/50 bg-cream-dark/50 flex items-center justify-center rotate-[3deg]">
          <span className="font-serif text-[5px] md:text-[7px] text-charcoal-light uppercase">España</span>
        </div>
      </div>

      {/* Postage stamp 7 - Thailand */}
      <div className="absolute top-[35%] right-[3%] md:right-[8%] animate-float-slow">
        <div className="h-9 w-7 md:h-13 md:w-10 rounded border-2 border-dashed border-tan/60 bg-cream-dark/50 flex items-center justify-center rotate-[-5deg]">
          <span className="font-serif text-[5px] md:text-[7px] text-charcoal-light uppercase">ไทย</span>
        </div>
      </div>

      {/* Postmark circle - Buenos Aires */}
      <div className="hidden md:block absolute top-[30%] left-[5%] animate-float-slow">
        <div className="h-20 w-20 rounded-full border-2 border-tan/60 flex items-center justify-center -rotate-12">
          <div className="text-center">
            <div className="font-serif text-[6px] text-charcoal-light uppercase tracking-wider">Buenos Aires</div>
            <div className="font-serif text-[10px] text-charcoal-light">1987</div>
          </div>
        </div>
      </div>

      {/* Postmark circle - Paris */}
      <div className="hidden md:block absolute top-[65%] right-[20%] animate-float">
        <div className="h-16 w-16 rounded-full border-2 border-secondary/50 flex items-center justify-center rotate-[20deg]">
          <div className="text-center">
            <div className="font-serif text-[5px] text-charcoal-light uppercase tracking-wider">Paris</div>
            <div className="font-serif text-[8px] text-charcoal-light">1963</div>
          </div>
        </div>
      </div>

      {/* Postmark circle - NYC */}
      <div className="absolute top-[45%] right-[3%] animate-float-slow">
        <div className="h-10 w-10 md:h-14 md:w-14 rounded-full border border-tan/40 flex items-center justify-center rotate-[8deg]">
          <div className="text-center">
            <div className="font-serif text-[4px] md:text-[5px] text-charcoal-light uppercase">NYC</div>
            <div className="font-serif text-[6px] md:text-[7px] text-charcoal-light">1952</div>
          </div>
        </div>
      </div>

      {/* Postmark circle - Tokyo */}
      <div className="hidden md:block absolute top-[18%] right-[8%] animate-float-delayed">
        <div className="h-14 w-14 rounded-full border border-burgundy/30 flex items-center justify-center rotate-[-15deg]">
          <div className="text-center">
            <div className="font-serif text-[5px] text-charcoal-light uppercase tracking-wider">Tokyo</div>
            <div className="font-serif text-[7px] text-charcoal-light">1971</div>
          </div>
        </div>
      </div>

      {/* Postmark circle - Cairo */}
      <div className="hidden md:block absolute bottom-[30%] left-[18%] animate-float">
        <div className="h-12 w-12 rounded-full border border-tan/50 flex items-center justify-center rotate-[25deg]">
          <div className="text-center">
            <div className="font-serif text-[5px] text-charcoal-light uppercase tracking-wider">Cairo</div>
            <div className="font-serif text-[7px] text-charcoal-light">1959</div>
          </div>
        </div>
      </div>

      {/* Envelope corner 1 */}
      <div className="hidden md:block absolute bottom-40 right-[8%] animate-float">
        <div className="h-12 w-16 bg-cream-dark/30 border border-tan/40 rotate-6" />
      </div>

      {/* Envelope corner 2 */}
      <div className="hidden md:block absolute top-[50%] left-[15%] animate-float-delayed">
        <div className="h-10 w-14 bg-cream-dark/20 border border-secondary/30 rotate-[-10deg]" />
      </div>

      {/* Envelope corner 3 */}
      <div className="hidden md:block absolute top-[75%] left-[40%] animate-float-slow">
        <div className="h-8 w-12 bg-cream-dark/25 border border-tan/30 rotate-[12deg]" />
      </div>

      {/* Handwritten line decoration 1 */}
      <div className="hidden md:block absolute bottom-[35%] left-[20%] animate-float-delayed">
        <div className="h-px w-24 bg-gradient-to-r from-transparent via-tan to-transparent rotate-[-5deg]" />
      </div>

      {/* Handwritten line decoration 2 */}
      <div className="hidden md:block absolute top-[25%] right-[25%] animate-float-slow">
        <div className="h-px w-20 bg-gradient-to-r from-transparent via-secondary/50 to-transparent rotate-[10deg]" />
      </div>

      {/* Handwritten line decoration 3 */}
      <div className="hidden md:block absolute bottom-[55%] right-[35%] animate-float">
        <div className="h-px w-16 bg-gradient-to-r from-transparent via-tan/60 to-transparent rotate-[-3deg]" />
      </div>

      {/* Handwritten line decoration 4 */}
      <div className="hidden md:block absolute top-[42%] left-[35%] animate-float-delayed">
        <div className="h-px w-18 bg-gradient-to-r from-transparent via-burgundy/30 to-transparent rotate-[7deg]" />
      </div>

      {/* Postage stamp 8 - Morocco */}
      <div className="absolute bottom-[20%] left-[3%] md:left-[8%] animate-float-slow">
        <div className="h-9 w-10 md:h-12 md:w-14 rounded border-2 border-dashed border-primary/30 bg-cream-dark/50 flex items-center justify-center -rotate-6">
          <span className="font-serif text-[5px] md:text-[7px] text-charcoal-light uppercase">Morocco</span>
        </div>
      </div>

      {/* Postage stamp 9 - India */}
      <div className="absolute bottom-[40%] right-[12%] md:right-[10%] animate-float">
        <div className="h-8 w-9 md:h-11 md:w-12 rounded border-2 border-dashed border-burgundy/30 bg-cream-dark/50 flex items-center justify-center rotate-[15deg]">
          <span className="font-serif text-[5px] md:text-[7px] text-charcoal-light uppercase">भारत</span>
        </div>
      </div>

      {/* Postage stamp 10 - Brazil */}
      <div className="hidden md:block absolute top-[40%] left-[25%] animate-float-delayed">
        <div className="h-10 w-12 rounded border-2 border-dashed border-tan/50 bg-cream-dark/50 flex items-center justify-center rotate-[-4deg]">
          <span className="font-serif text-[6px] text-charcoal-light uppercase">Brasil</span>
        </div>
      </div>

      {/* Postage stamp 11 - Australia */}
      <div className="hidden md:block absolute bottom-[15%] right-[30%] animate-float-slow">
        <div className="h-11 w-9 rounded border-2 border-dashed border-secondary/40 bg-cream-dark/50 flex items-center justify-center rotate-[8deg]">
          <span className="font-serif text-[6px] text-charcoal-light uppercase">Australia</span>
        </div>
      </div>

      {/* Postage stamp 12 - Egypt */}
      <div className="hidden md:block absolute top-[58%] left-[42%] animate-float">
        <div className="h-9 w-11 rounded border-2 border-dashed border-tan/40 bg-cream-dark/50 flex items-center justify-center rotate-[-10deg]">
          <span className="font-serif text-[6px] text-charcoal-light uppercase">مصر</span>
        </div>
      </div>

      {/* Postage stamp 13 - Sweden */}
      <div className="hidden md:block absolute bottom-[50%] left-[8%] animate-float-delayed">
        <div className="h-10 w-8 rounded border-2 border-dashed border-burgundy/25 bg-cream-dark/50 flex items-center justify-center rotate-[6deg]">
          <span className="font-serif text-[6px] text-charcoal-light uppercase">Sverige</span>
        </div>
      </div>

      {/* Postage stamp 14 - Mexico */}
      <div className="absolute top-[82%] left-[20%] md:left-[25%] animate-float">
        <div className="h-8 w-9 md:h-10 md:w-12 rounded border-2 border-dashed border-tan/50 bg-cream-dark/50 flex items-center justify-center rotate-[-7deg]">
          <span className="font-serif text-[5px] md:text-[6px] text-charcoal-light uppercase">México</span>
        </div>
      </div>

      {/* Postage stamp 15 - Korea */}
      <div className="hidden md:block absolute top-[12%] left-[20%] animate-float-slow">
        <div className="h-11 w-8 rounded border-2 border-dashed border-secondary/35 bg-cream-dark/50 flex items-center justify-center rotate-[4deg]">
          <span className="font-serif text-[6px] text-charcoal-light uppercase">한국</span>
        </div>
      </div>

      {/* Decorative line 1 */}
      <div className="hidden md:block absolute top-[60%] right-[12%] animate-float">
        <div className="h-px w-16 bg-gradient-to-r from-transparent via-secondary to-transparent rotate-[15deg]" />
      </div>

      {/* Decorative line 2 */}
      <div className="hidden md:block absolute bottom-[25%] left-[30%] animate-float-slow">
        <div className="h-px w-20 bg-gradient-to-r from-transparent via-tan/70 to-transparent rotate-[-8deg]" />
      </div>

      {/* Decorative line 3 */}
      <div className="hidden md:block absolute top-[78%] right-[45%] animate-float-delayed">
        <div className="h-px w-14 bg-gradient-to-r from-transparent via-burgundy/40 to-transparent rotate-[3deg]" />
      </div>

      {/* Small stamp - UK */}
      <div className="absolute bottom-[60%] left-[2%] animate-float">
        <div className="h-7 w-6 md:h-10 md:w-8 rounded border border-dashed border-tan/60 bg-cream-dark/40 flex items-center justify-center rotate-[3deg]">
          <span className="font-serif text-[4px] md:text-[6px] text-charcoal-light uppercase">UK</span>
        </div>
      </div>

      {/* Small stamp - Peru */}
      <div className="absolute top-[88%] right-[15%] animate-float-delayed">
        <div className="h-7 w-8 md:h-9 md:w-10 rounded border border-dashed border-secondary/40 bg-cream-dark/40 flex items-center justify-center rotate-[-4deg]">
          <span className="font-serif text-[4px] md:text-[6px] text-charcoal-light uppercase">Perú</span>
        </div>
      </div>

      {/* Small stamp - Vietnam */}
      <div className="absolute bottom-[8%] left-[45%] animate-float-slow">
        <div className="h-6 w-7 md:h-8 md:w-9 rounded border border-dashed border-tan/50 bg-cream-dark/40 flex items-center justify-center rotate-[9deg]">
          <span className="font-serif text-[4px] md:text-[5px] text-charcoal-light uppercase">Việt Nam</span>
        </div>
      </div>
    </div>
  );
};

export default FloatingEphemera;
